import cn from "classnames";

import { StatusIcon } from "@/components/statusIcon/statusIcon.component";
import { Text, type TextProps } from "@/components/text/text.component";

import type { CompareCellValue } from "./compare.type";

export const CompareTableIcon = ({
  value,
  textClassName,
  textVariant = "body4",
}: CompareTableIconProps) => {
  if (typeof value === "string") {
    return (
      <Text
        component="p"
        variant={textVariant}
        className={cn("text-center", textClassName)}>
        {value}
      </Text>
    );
  }

  if (value === true) {
    return <StatusIcon variant="check" srOnlyLabel="Included" />;
  }

  return <StatusIcon variant="close" srOnlyLabel="Not included" />;
};

type CompareTableIconProps = {
  value: CompareCellValue | undefined;
  textClassName?: string;
  textVariant?: TextProps["variant"];
};
